// Curated paste languages: stored key → display label + download extension.
// Keep in sync with the backend (apps/backend/app/api_v1/pastes/constants.py)
// and the micro-site (apps/micro-site/src/services/languages.ts) — the backend
// validates keys at write time.

export const PASTE_LANGUAGES = [
  { key: 'plain', label: 'Plain text', ext: 'txt' },
  { key: 'python', label: 'Python', ext: 'py' },
  { key: 'javascript', label: 'JavaScript', ext: 'js' },
  { key: 'typescript', label: 'TypeScript', ext: 'ts' },
  { key: 'html', label: 'HTML', ext: 'html' },
  { key: 'css', label: 'CSS', ext: 'css' },
  { key: 'json', label: 'JSON', ext: 'json' },
  { key: 'yaml', label: 'YAML', ext: 'yaml' },
  { key: 'markdown', label: 'Markdown', ext: 'md' },
  { key: 'bash', label: 'Bash', ext: 'sh' },
  { key: 'sql', label: 'SQL', ext: 'sql' },
  { key: 'java', label: 'Java', ext: 'java' },
  { key: 'c', label: 'C', ext: 'c' },
  { key: 'cpp', label: 'C++', ext: 'cpp' },
  { key: 'csharp', label: 'C#', ext: 'cs' },
  { key: 'go', label: 'Go', ext: 'go' },
  { key: 'rust', label: 'Rust', ext: 'rs' },
  { key: 'ruby', label: 'Ruby', ext: 'rb' },
  { key: 'php', label: 'PHP', ext: 'php' },
  { key: 'kotlin', label: 'Kotlin', ext: 'kt' },
  { key: 'swift', label: 'Swift', ext: 'swift' },
  { key: 'dart', label: 'Dart', ext: 'dart' },
  { key: 'scala', label: 'Scala', ext: 'scala' },
  { key: 'r', label: 'R', ext: 'r' },
  { key: 'perl', label: 'Perl', ext: 'pl' },
  { key: 'lua', label: 'Lua', ext: 'lua' },
  { key: 'dockerfile', label: 'Dockerfile', ext: 'dockerfile' },
  { key: 'ini', label: 'INI / TOML', ext: 'ini' },
  { key: 'xml', label: 'XML', ext: 'xml' },
  { key: 'diff', label: 'Diff', ext: 'diff' },
];

// Mirrors the backend cap (pastes/constants.py MAX_PASTE_BYTES).
export const MAX_PASTE_BYTES = 512 * 1024;

export function languageLabel(key) {
  const lang = PASTE_LANGUAGES.find((l) => l.key === key);
  return lang ? lang.label : key || 'Plain text';
}

// UTF-8 byte length — the backend limit is bytes, not characters.
export function byteLength(str) {
  return new TextEncoder().encode(str || '').length;
}
